module.exports = "section {\n  margin: 25px;\n}\n\nth {\n  text-align: center;\n}\n\n.capitalize {\n    text-transform: capitalize;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/financial/fines-view/fines-view.component.css
// module id = ./src/app/financial/fines-view/fines-view.component.css
// module chunks = main